import { render, staticRenderFns } from "./AssociatedServicesCard.vue?vue&type=template&id=a097c510"
import script from "./AssociatedServicesCard.vue?vue&type=script&lang=js"
export * from "./AssociatedServicesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports